module.exports = __webpack_public_path__ + "static/img/019.959a271.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/datav-gejiachecun/019.png
// module id = l5e4
// module chunks = 1